import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import App from 'modules/App';
const ButtonsContainer = ({ children })=>{
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    return /*#__PURE__*/ _jsx("div", {
        className: "buttonsContainer row no-gutters",
        children: /*#__PURE__*/ _jsx("div", {
            className: cn('col-12', {
                'col-lg-9': !isMobileDisplayMode
            }),
            children: children
        })
    });
};
export default ButtonsContainer;
